(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-finder-result"]) return;
  try {
    
  class ProductFinderResult extends HTMLElement {
    constructor() {
      super();
    }
    addToCart(data) {
      this.classList.add('loading');
      const cartDrawerSectionId = document.querySelector('cart-drawer')?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
      if(!cartDrawerSectionId) {
        console.error('cart-drawer-section not found', 'error');
        return;
      }
      data.sections = cartDrawerSectionId;
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(response.status && response.status != 200) {
          console.error(response.description, 'error');
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: response
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('productfinder:atc', {
            bubbles: true,
            detail: {
              input: data,
              output: response
            }
          }));
          console.log('success', response);
        }
        this.classList.remove('loading');
        return response;
      })
      .catch((error) => {
        this.classList.remove('loading');
        console.error('Da ist wohl etwas schief gelaufen. Bitte versuchen sie es erneut.', 'error');
      });
    }
    singleAddToCart(result) {
      const variant_id = result?.dataset?.variantId ? Number(result?.dataset?.variantId) : null;
      if(!variant_id) return;
      const data = {items: [
        {
          id: variant_id,
          quantity: 1,
          properties: {
            '_product-finder': true
          }
        }
      ]};
      result.classList.add('loading');
      this.addToCart(data)
      .then(resonse => {
        result.classList.remove('loading');
      });
    }
    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      if(!params.get('result')) {
        return;
      }
      const decodedResultKeys = atob(params.get('result')).replaceAll('-', '+').replaceAll('_', '/')?.split(',')?.map(key => key.trim());
      const template = this.querySelector('template.pf-results-source')?.content;
      const results = [];
      if(!decodedResultKeys || decodedResultKeys.length < 1 || !template) {
        return;
      }
      decodedResultKeys.forEach(decodedResultKey => {
        const productNode = template?.querySelector(`.pf-result[data-result-key="${decodedResultKey}"]`)?.cloneNode(true);
        if(productNode) {
          results.push(productNode);
        }
      });
      const main_recommendation = this.querySelector('.pf-recommendation');
      const secondary_crosssell = this.querySelector('.pf-cross-sell-slider');
      if(results[0]){
        main_recommendation.append(results[0]);
      }
      if(results[1]) {
        secondary_crosssell.append(results[1]);
      }
      if(results[2]) {
        secondary_crosssell.append(results[2]);
      }
      if(results[3]) {
        secondary_crosssell.append(results[3]);
      }
      this.querySelectorAll('.pf-result')?.forEach(result => {
        const result_atc = result.querySelector('.pf-add-to-cart');
        result_atc.addEventListener('click', e => {
          if(result_atc.disabled) return;
          this.singleAddToCart(result);
        });
      });
    }
  }
  if(!customElements.get('product-finder-result')) {
    customElements.define('product-finder-result', ProductFinderResult);
  } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"]) return;
  try {
    
  class ProductFinder extends HTMLElement {
    constructor() {
      super();
    }
    reset() {
      this.goTo(0);
      this.querySelectorAll('input').forEach(input => {
        input.removeAttribute('checked');
        input.checked = false;
      });
    }
    addToCart(data) {
      this.classList.add('loading');
      const cartDrawerSectionId = document.querySelector('cart-drawer')?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
      if(!cartDrawerSectionId) {
        console.error('cart-drawer-section not found', 'error');
        return;
      }
      data.sections = cartDrawerSectionId;
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(response.status && response.status != 200) {
          console.error(response.description, 'error');
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: response
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('productfinder:atc', {
            bubbles: true,
            detail: {
              input: data,
              output: response
            }
          }));
          console.log('success', response);
        }
        this.classList.remove('loading');
        return response;
      })
      .catch((error) => {
        this.classList.remove('loading');
        console.error('Da ist wohl etwas schief gelaufen. Bitte versuchen sie es erneut.', 'error');
      });
    }
    multiAddToCart(){
      const data = {items: []};
      this.querySelectorAll('.pf-result:not([data-sold-out])').forEach(result => {
        const variant_id = result?.dataset?.variantId ? Number(result?.dataset?.variantId) : null;
        const item = {
          id: variant_id,
          quantity: 1,
          properties: {
            '_product-finder': true
          }
        };
        data.items.push(item);
      });
      if(data.items.length > 0) {
        this.addAllToCart?.classList.add('loading');
        this.addToCart(data)
        .then(resonse => {
          this.addAllToCart?.classList.remove('loading');
        });
      }
    }
    singleAddToCart(result) {
      const variant_id = result?.dataset?.variantId ? Number(result?.dataset?.variantId) : null;
      if(!variant_id) return;
      const data = {items: [
        {
          id: variant_id,
          quantity: 1,
          properties: {
            '_product-finder': true
          }
        }
      ]};
      result.classList.add('loading');
      this.addToCart(data)
      .then(resonse => {
        result.classList.remove('loading');
      });
    }
    updateNavButtons() {
      const currentStep = this.steps[this.state.step];
      const questions = Array.from(currentStep.querySelectorAll('.pf-question[data-optional="false"]'));
      const stepComplete = questions.every(question => !!question.querySelector('.pf-answer-input:checked'));
      if(stepComplete && (this.state.step + 1) < this.steps.length) {
        this.nextButtons.forEach(button => button.removeAttribute('disabled'));
      } else {
        this.nextButtons.forEach(button => button.setAttribute('disabled', ''));
      }
      if(this.state.step > 0) {
        this.prevButtons.forEach(button => button.removeAttribute('disabled'));
      } else {
        this.prevButtons.forEach(button => button.setAttribute('disabled', ''));
      }
    }
    setAnswer(e) {
      const question = e.target.closest('.pf-question');
      const continueButton = question.querySelector('.pf-continue-wrapper');
      const questionComplete = !!question.querySelector('.pf-answer-input:checked');
      /* if single choice and not optional -> auto continue on answer select */
      if(e.target.type === 'radio' && question.dataset.optional === 'false' && questionComplete){
        this.nextStep();
        return;
      }
      /* if mutliple choice -> manual continue when you are done */
      if(e.target.type === 'checkbox') {
        if(questionComplete) {
          continueButton?.classList?.remove('pf-hidden');
        } else {
          continueButton?.classList?.add('pf-hidden');
        }
      }
      this.updateNavButtons();
    }
    prepareResult() {
      const resultProducts = this.querySelector('template.pf-results-source')?.content?.querySelectorAll('.pf-result');
      const results = Object.fromEntries(Array.from(resultProducts).map(product => [product.dataset.resultKey, {score: null, node: product.cloneNode(true)}]));
      const checkedAnswers = this.querySelectorAll('.pf-question .pf-answer-input:checked');
      for (const answer of checkedAnswers) {
        for (const [key, value] of Object.entries(answer.dataset)) {
          if(key.startsWith('score')){
            const formattedKey = key.replace('score', '').toLowerCase();
            if(typeof results[formattedKey].score === 'number') {
              results[formattedKey].score += Number(value);
            } else {
              results[formattedKey].score = Number(value);
            }
          }
        }
      }
      console.log(results);
      console.log(Array.from(Object.values(results)).sort((a, b) => b.score - a.score).map((value) => value));
      const sortedResults = Array.from(Object.values(results)).sort((a, b) => b.score - a.score).map((value) => value.node);
      const main_recommendation = this.querySelector('.pf-recommendation');
      const secondary_crosssell = this.querySelector('.pf-cross-sell-slider');
      main_recommendation.querySelectorAll('.pf-result').forEach(result => result.remove());
      secondary_crosssell.querySelectorAll('.pf-result').forEach(result => result.remove());

      main_recommendation.append(sortedResults[0]);
      secondary_crosssell.append(sortedResults[1]);
      secondary_crosssell.append(sortedResults[2]);
      secondary_crosssell.append(sortedResults[3]);

      const available_count = this.querySelector('[data-available-count]');
      if(available_count) {
        available_count.innerHTML = `(${this.querySelectorAll('.pf-result:not([data-sold-out])').length})`;
      }
      this.querySelectorAll('.pf-result')?.forEach(result => {
        const result_atc = result.querySelector('.pf-add-to-cart');
        result_atc.addEventListener('click', e => {
          if(result_atc.disabled) return;
          this.singleAddToCart(result);
        });
      });
    }
    goTo(stepIndex) {
      const index = Number(stepIndex);
      if(index < 0 || index >= this.stepCount) return;
      this.state.step = index;
      this.style.setProperty("--current-step", this.state.step);
      this.updateNavButtons();
    }
    prevStep(e = null) {
      if(e && e.target && e.target.disabled) {
        return;
      }
      if(this.state.step > 0) {
        this.state.step--;
        this.style.setProperty("--current-step", this.state.step);
        this.progress.innerHTML = `${Math.round(this.state.step / (this.stepCount - 1) * 100)}%`;
        document.documentElement.dispatchEvent(new CustomEvent('productfinder:step', {
          bubbles: true,
          detail: {
            stepIndex: this.state?.step
          }
        }));
      }
      this.updateNavButtons();
    }
    nextStep(e = null) {
      if(e && e.target && e.target.disabled) {
        return;
      }
      /* prevent ending the quiz if a mandatory question has no answer */
      if (this.state.step == (this.stepCount - 2)) {
        const questions = Array.from(this.querySelectorAll('.pf-question[data-optional="false"]'));
        const complete = questions.every(question => question.querySelector('.pf-answer-input:checked'));
        if(!complete) {
          return;
        }
      }
      if(this.state.step < (this.stepCount - 1)) {
        this.state.step++;
        this.style.setProperty("--current-step", this.state.step);
        this.progress.innerHTML = `${Math.round(this.state.step / (this.stepCount - 1) * 100)}%`;
        document.documentElement.dispatchEvent(new CustomEvent('productfinder:step', {
          bubbles: true,
          detail: {
            stepIndex: this.state?.step
          }
        }));
      }
      /* pre-render result if the page before the result page was reached  */
      if (this.state.step == (this.stepCount - 2)) {
        this.prepareResult();
      }
      if (this.state.step == (this.stepCount - 1)) {
        this.classList.add('pf-last');
        document.documentElement.dispatchEvent(new CustomEvent('productfinder:end', {
          bubbles: true,
          detail: {
            stepIndex: this.state?.step
          }
        }));
        this.progressBar.addEventListener('transitionend', e => {
          this.classList.add('pf-complete');
          console.log('completed quiz');
        }, {once: true});
      }
      this.updateNavButtons();
    }
    connectedCallback() {
      this.prevButtons = this.querySelectorAll('.pf-prev');
      this.nextButtons = this.querySelectorAll('.pf-next');
      this.steps = this.querySelectorAll('.pf-step');
      this.progressBar = this.querySelector('.pf-progress');
      this.progress = this.querySelector('[data-progress]');
      this.addAllToCart = this.querySelector('.pf-add-all-to-cart');
      this.stepCount = this.steps.length;
      this.answerInputs = this.querySelectorAll('input.pf-answer-input');

      this.state = {
        step: 0,
        answers: Array.from(this.querySelectorAll('.pf-answer-input:checked')).map(answer => answer.id)
      };
      this.reset();
      document.documentElement.dispatchEvent(new CustomEvent('productfinder:start', {
        bubbles: true,
        detail: {
          stepIndex: this.state?.step
        }
      }));
      for (const button of this.prevButtons) {
        button.addEventListener('click', this.prevStep.bind(this));
      }
      for (const button of this.nextButtons) {
        button.addEventListener('click', this.nextStep.bind(this));
      }
      for (const input of this.answerInputs) {
        input.addEventListener('input', this.setAnswer.bind(this));
      }
      this.addAllToCart?.addEventListener('click', this.multiAddToCart.bind(this));
      this.style.setProperty("--current-step", this.state.step);
      this.style.setProperty("--step-count", this.stepCount);
      this.updateNavButtons();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', e => {
          const step = e.target.classList.contains('pf-step') ? e.target : e.target.closest('.pf-step');
          if(!step) return;
          const index = Array.from(step.parentNode.children).indexOf(step);
          if(index < 0) return;
          this.goTo(index);
        });
      }
      document.documentElement.dispatchEvent(new CustomEvent('productfinder:step', {
        bubbles: true,
        detail: {
          stepIndex: this.state?.step
        }
      }));
    }
  }

  /* Productfinder progress tracking */
  document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'pf_tracked_progress';

    const pushProgress = (stepIndex, pfElement) => {
      const totalSteps = pfElement.stepCount;
      if (!totalSteps || totalSteps <= 1) return;

      const progressPercent = Math.round((stepIndex / (totalSteps - 1)) * 100);
      const progressString = progressPercent + '%';

      let trackedSteps = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');

      if (!trackedSteps.includes(progressString)) {
        if (window.Shopify && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('product_finder_progression', {
            progress: progressString,
            step_index: stepIndex,
            total_steps: totalSteps
          });

          trackedSteps.push(progressString);
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trackedSteps));
        }
      }
    };

    document.addEventListener('productfinder:step', (event) => {
      const pfElement = event.target.closest('product-finder') || document.querySelector('product-finder');
      if (!pfElement) return;

      const stepIndex = event.detail.stepIndex;
      pushProgress(stepIndex, pfElement);
    });
  });

  if(!customElements.get('product-finder')) {
    customElements.define('product-finder', ProductFinder);
  } 

  } catch(e) { console.error(e); }
})();
})();
